import { doc, updateDoc } from 'firebase/firestore';
import getFirestore from '..';

async function updateDocument(documentpath: string, data: any) {
  const db = getFirestore();
  const docRef = doc(db, documentpath);
  return updateDoc(docRef, data);
}
export default updateDocument;
